import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { getUtility } from '@livable/saas-react-components';
import { FormControlLabel, FormGroup, Switch, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { events, track } from 'src/configs/amplitude';
import { useStore } from 'src/stores';
import FinancialTextInput from 'src/components/shared/FinancialTextInput';
import useUtilityStyles from './styles';
export const Utility = observer(_ref => {
  let utility = _ref.utility,
    utilityId = _ref.utilityId;
  const classes = useUtilityStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const utilityData = getUtility(utility.title);
  const _useState = useState(store.enrollResident.getUtilityType(utilityId) ? store.enrollResident.getUtilityType(utilityId) : 'RatioBilling'),
    _useState2 = _slicedToArray(_useState, 2),
    billing = _useState2[0],
    setBilling = _useState2[1];
  const handleBillingChange = (e, v) => {
    setBilling(v);
    const value = v ? 'RatioBilling' : 'Optout';
    store.enrollResident.changeUtilityType(utilityId, value);
    track(events.changed('Utility Billing'), {
      billing: value
    });
  };
  const handleUtilityCapChangeV2 = value => {
    track(events.filled('Utility Cap'));
    store.enrollResident.changeUtilityCap(utilityId, value === null ? null : Number(value));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.utility
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.flex, " ").concat(classes.xsSection, " ").concat(classes.whiteBlock)
  }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Switch, null),
    checked: billing,
    onChange: handleBillingChange
  })), utilityData.icon(), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, utility.title), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, utility.utilityProviderName))), /*#__PURE__*/React.createElement("div", {
    className: classes.utilityActions
  }, /*#__PURE__*/React.createElement(FinancialTextInput, {
    disabled: !billing,
    handleInputChange: handleUtilityCapChangeV2,
    infoMark: t('enrollment_modal.utility_cap_help_info'),
    inputLabel: 'Utility cap',
    valueExt: store.enrollResident.getUtilityCap(utilityId),
    withAdorment: true
  })));
});